import React from 'react';
import './MySpinner.css';

const MySpinner = ({ size = 'medium', color = '#007AFF' }) => {
  const spinnerSize = {
    small: 16,
    medium: 24,
    large: 32
  }[size] || 24;

  return (
    <div 
      className="spinner-container" 
      style={{ '--spinner-size': `${spinnerSize}px`, '--spinner-color': color }}
      role="status"
      aria-label="Loading"
    >
      <div className="spinner"></div>
    </div>
  );
};

export default MySpinner;